import React, { useState } from "react";
import "./login.scss";
import ILogin from "./ILogin";
import OtpInput from "./OtpInput";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  LOGIN_GUEST_USER,
  GENERATE_LOGIN_OTP_SUCCESS,
} from "../../redux/constant";
import RestoTemplate from "../../Assets/RestaurantBanneTemplate.png";

const LoginPage = ({ packageType: propPackageType }) => {
  const [otpStage, setOtpStage] = useState(false);
  const { restaurant, id, table } = useParams();
  const otpSendSuccessfully = useSelector((state) => state?.user.generateOTP);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const packageType = propPackageType || sessionStorage.getItem("packageType");
  const showBannerInLoginPage = JSON.parse(
    sessionStorage.getItem("showBannerInLoginPage"),
  ); //sessionStorage.getItem("showBannerInLoginPage");
  const customerPortalTheme = sessionStorage.getItem("customer_portal_theme");
  const loginPageImageURL = sessionStorage.getItem("loginPageImage");
  console.log("packageType", packageType);
  console.log("showBannerInLoginPage", showBannerInLoginPage);
  console.log("customerPortalTheme", customerPortalTheme);
  console.log("loginPageImageURL", loginPageImageURL);

  //sessionStorage.clear()
  const guestLogin = () => {
    dispatch({ type: LOGIN_GUEST_USER, payload: true });
    // localStorage.setItem("guestUser", "true");
    localStorage.setItem("restaurant", restaurant);
    localStorage.setItem("restaurantId", id);
    localStorage.setItem("table", table);
    navigate(`/${restaurant}/${id}/${table}/menu`);
  };
  const handleBackToPhone = () => {
    dispatch({ type: GENERATE_LOGIN_OTP_SUCCESS, payload: null });
    setOtpStage(false);
  };

  return (
    <div className="welcome-theme">
      {showBannerInLoginPage ? (
        <div className="banner">
          <div className="banner-wrapper">
            <img src={RestoTemplate} alt="Banner" className="banner-image" />
            <h2 className="banner-text">
              {restaurant !== "undefined" ? "Welcome to " + restaurant : ""}
            </h2>
          </div>
        </div>
      ) : (
        <div className="brandBanner">
          <br />
          {restaurant !== "undefined" ? "Welcome to " + restaurant : ""}
        </div>
      )}

      <div
        className={
          showBannerInLoginPage ? "bottomContainer" : "bottomContainerRadius"
        }
      >
        {packageType !== "catelog" && packageType !== "counter express" ? (
          <>
            {otpStage ?  <OtpInput onBack={handleBackToPhone} /> : <ILogin setOtpStage={setOtpStage} />}
            <br />
          </>
        ) : packageType === "catelog" || table === "cat" ? (
          <button className="full-btn skip" onClick={guestLogin}>
            Explore Menu
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default LoginPage;
